import { Button } from 'base/ui/button';
import { IconChevronRight, IconRefresh, IconStars } from 'base/ui/icons';
import { Inline, Rows, SpacerGrow } from 'base/ui/layout';
import { MenuButton } from 'base/ui/menu';
import { MenuModel } from 'base/ui/menu_model';
import { TextSmallLight } from 'base/ui/typography';
import React from 'react';
import defaultCategoryPreview from './default_category_preview.file.svg';
import styles from './ui.css';

export function ComponentPreviewLayout({
  name,
  isEdited,
  menu,
  menuEnabled,
  onReplaceComponent,
}: {
  name: React.ReactNode;
  isEdited: boolean;
  menu: MenuModel;
  menuEnabled: boolean;
  onReplaceComponent: () => void;
}) {
  menu;
  return (
    <div
      className={styles.componentPreviewContainer}
      onClick={onReplaceComponent}
    >
      <div className={styles.componentPreviewContent}>
        <Inline spacing={12} yalign="center">
          <img
            src={defaultCategoryPreview}
            width={32}
            height={32}
            className={styles.componentImage}
            alt="Component category image"
          />
          <TextSmallLight lineClamp={1} color="black">
            {name}
            {isEdited ? ' (Edited)' : ''}
          </TextSmallLight>
          <SpacerGrow />
          <MenuButton
            menu={menu}
            search="hidden"
            icon={IconRefresh}
            variant="tertiary"
            size="small"
            disabled={!menuEnabled}
          />
          <span className={styles.componentChevronRight}>
            <IconChevronRight />
          </span>
        </Inline>
      </div>
    </div>
  );
}

export function ComponentPreviewLoading() {
  return (
    <div className={styles.componentPreviewContainer}>
      <div className={styles.placeholder}>
        <TextSmallLight color="grey">Loading preview</TextSmallLight>
      </div>
    </div>
  );
}

export function FormEmptyState({
  icon: Icon,
  children,
  buttonLabel,
  onClick,
}: {
  icon: React.ComponentType;
  children: React.ReactNode;
  buttonLabel?: string;
  onClick?: () => void;
}) {
  return (
    <div className={styles.emptyState}>
      <Rows spacing={buttonLabel ? 16 : 8} xalign="start">
        <div className={styles.emptyStateIcon}>
          <Icon />
        </div>
        <TextSmallLight color="grey">{children}</TextSmallLight>
        {buttonLabel && (
          <Button
            label={buttonLabel}
            variant="primary"
            onClick={onClick}
            fullWidth
          />
        )}
      </Rows>
    </div>
  );
}

export function RequiredStar() {
  return <span className={styles.requiredStar}> *</span>;
}

export function LabelAiIcon() {
  return (
    <span className={styles.labelAiIcon}>
      <IconStars />
    </span>
  );
}
